import authFetchHandler from '../../tools/auth/authFetchHandler'
import { codeFilesDatabase } from '../../databaseworker/databases'
import { textToBlob } from '../../databaseworker/fileUtils'
import { metadataDeserializer, metadataSerializer } from '../../databaseworker/jsonUtils'
import { lowToleranceAuthFetcher } from '../utils/low-tolerance-auth-fetcher'

const LOGGED_OUT_FILE_ID = 'loggedOutFile'
const CODE_FILES_BATCH_SIZE = 200 // Server-side limit of the getCodeFiles endpoint
class CodeFileGateway {
  async saveToCloud(fileId, content, metadata) {
    const form = new FormData()
    form.append('file', content instanceof Blob ? content : textToBlob(content), fileId)
    if (!!metadata) {
      form.append('metadata', JSON.stringify(metadata, metadataSerializer))
    }

    return await lowToleranceAuthFetcher(`postFile/${encodeURIComponent(codeFilesDatabase.name)}`, {
      method: 'POST',
      body: form,
    }, [], false, true)
  }

  async getFromCloud(fileId, initialization, lowTolerance = true) {
    let handleFetch = lowTolerance ? lowToleranceAuthFetcher : authFetchHandler
    const resp = await handleFetch(`getFile/${encodeURIComponent(codeFilesDatabase.name)}/${fileId}`, {
      method: 'GET',
    }, [], initialization)
    if (resp.status === 200) {
      return await resp.text()
    }
  }

  // Returns { [fileId]: contents | null } for up to CODE_FILES_BATCH_SIZE ids
  async getManyFromCloud(fileIds) {
    const resp = await lowToleranceAuthFetcher('getCodeFiles', {
      method: 'POST',
      body: JSON.stringify({ ids: fileIds }),
    }, [], true)
    return (await resp.json()).files
  }

  async deleteFromCloud(fileId, metadata) {
    return await lowToleranceAuthFetcher(`delete/${encodeURIComponent(codeFilesDatabase.name)}/${fileId}`, {
      method: 'POST',
      body: JSON.stringify({
        metadata,
      }),
    })
  }

  async saveMetadataToCloud(metadata) {
    return await lowToleranceAuthFetcher(`postMetadata/${encodeURIComponent(codeFilesDatabase.name)}`, {
      method: 'POST',
      body: JSON.stringify({
        metadata,
      }),
    })
  }

  async getMetaDataFromCloud(fileId) {
    try {
      const resp = await authFetchHandler(`files/code/${fileId}/meta-data`,
        {
          method: 'GET',
        })

      return await resp.json()
    } catch (err){
      //
    }
  }

  async getFileTreeFromCloud() {
    const resp = await lowToleranceAuthFetcher('getUserFileTree', {
      method: 'GET',
    }, [], true)
    if (resp.status !== 200) {
      return
    }
    // Deserialize the response into our tree structure
    return JSON.parse(await resp.text(), metadataDeserializer)
  }
}

const codeFileGateway = new CodeFileGateway()
export {
  LOGGED_OUT_FILE_ID,
  CODE_FILES_BATCH_SIZE,
  codeFileGateway,
}